import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

interface Props {
  progress: number // must be between 0 and 1
}

const LinearProgress = ({ progress }: Props) => {
  const [width, setWidth] = React.useState(0)

  return (
    <Back onLayout={(evt) => setWidth(evt.nativeEvent.layout.width)}>
      <Active width={width * Math.min(progress, 1)} />
    </Back>
  )
}

export default LinearProgress

const Back = styled(View)`
  height: 4px;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.primaryLight};
`

const Active = styled(Back)<{ width: number }>`
  background-color: ${(props) => props.theme.colors.primary};
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => props.width};
`
